
const formatter = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2 })

const price = function (price) {
  return formatter.format(parseInt(price) / 100).replace('-', '- ') + ' €'
}
const priceWithoutEuro = function (price) {
  return formatter.format(parseInt(price) / 100).replace('-', '- ')
}
const pricePositiv = function (price) {
  return formatter.format(parseInt(price) / 100).replace('-', '+ ') + ' €'
}

export { price }

export default {
  methods: {
    price,
    priceWithoutEuro,
    pricePositiv
  }
}
